"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVerifyEmailConfirmDto = instanceOfVerifyEmailConfirmDto;
exports.VerifyEmailConfirmDtoFromJSON = VerifyEmailConfirmDtoFromJSON;
exports.VerifyEmailConfirmDtoFromJSONTyped = VerifyEmailConfirmDtoFromJSONTyped;
exports.VerifyEmailConfirmDtoToJSON = VerifyEmailConfirmDtoToJSON;
exports.VerifyEmailConfirmDtoToJSONTyped = VerifyEmailConfirmDtoToJSONTyped;
/**
 * Check if a given object implements the VerifyEmailConfirmDto interface.
 */
function instanceOfVerifyEmailConfirmDto(value) {
    if (!('otp' in value) || value['otp'] === undefined)
        return false;
    return true;
}
function VerifyEmailConfirmDtoFromJSON(json) {
    return VerifyEmailConfirmDtoFromJSONTyped(json, false);
}
function VerifyEmailConfirmDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'otp': json['otp'],
    };
}
function VerifyEmailConfirmDtoToJSON(json) {
    return VerifyEmailConfirmDtoToJSONTyped(json, false);
}
function VerifyEmailConfirmDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'otp': value['otp'],
    };
}
